import {
  NavigationTabGroup as SharedNavigationTabGroup,
  type NavigationTabGroupProps,
} from "@sellar-io/components";
import { useEffect } from "react";
import { useSearchParamState } from "../../hooks/useSearchParamState";

type FrontendNavigationTabGroupProps<Tabs extends readonly string[]> = Omit<
  NavigationTabGroupProps<Tabs>,
  "value" | "defaultValue" | "onValueChange"
> & {
  defaultValue?: Tabs[number];
  parameterKey?: string;
};

export const NavigationTabGroup = <Tabs extends readonly string[]>({
  tabs,
  defaultValue,
  parameterKey = "tab",
  ...props
}: FrontendNavigationTabGroupProps<Tabs>) => {
  const firstTab = tabs[0];
  if (!firstTab) throw new Error("Cannot find first tab");

  const fallbackTab = defaultValue ?? firstTab;
  const [tabName, setTabName] = useSearchParamState<Tabs[number]>(
    parameterKey,
    fallbackTab,
  );

  const selectedTabName = tabs.includes(tabName) ? tabName : fallbackTab;

  useEffect(() => {
    if (tabName !== selectedTabName) {
      setTabName(selectedTabName);
    }
  }, [tabName, selectedTabName, setTabName]);

  return (
    <SharedNavigationTabGroup
      {...props}
      tabs={tabs}
      value={selectedTabName}
      onValueChange={setTabName}
    />
  );
};
